import { useState, useMemo, useContext, useEffect } from 'react'
import Loader from '../_general/Loader'
import ProfileContext from '../../context/Profile'
import FancyDropdown from '../_control/FancyDropdown'
import LocalStorage from '../../services/LocalStorage'
import useRawState from '../../hooks/useRawState'

export default function AdminAnalyticsClubSelector({ ...props }) {

    const { data: profile } = useContext(ProfileContext)

    const { data: unpaginatedClubs } = useRawState(profile?.admin ? `/api/current/clubs/list` : undefined, {
        pagination: false
    })

    const [selectedClub, setSelectedClub] = useState(
        LocalStorage.getItem('adminAnalyticsClub') ?
            Number(LocalStorage.getItem('adminAnalyticsClub'))
            : undefined
    )

    const clubsOptions = useMemo(() => {
        return unpaginatedClubs?.map(c => ({
            value: c.id,
            label: c.name,
        })) ?? []
    }, [unpaginatedClubs])

    useEffect(() => {
        if (!selectedClub) {
            LocalStorage.removeItem('adminAnalyticsClub')
            return
        }
        LocalStorage.setItem('adminAnalyticsClub', selectedClub)
    }, [selectedClub])

    return unpaginatedClubs ?
        <FancyDropdown
            compact={true}
            subtle={true}
            isClearable={true}
            options={clubsOptions}
            onChange={val => setSelectedClub(val?.value)}
            value={clubsOptions?.find(opt => opt.value === selectedClub)}
            placeholder={'None'}
        />
        :
        <Loader size={'1em'} />
}